module.exports = __webpack_public_path__ + "fonts/GT-Bold.4fccb40f.otf";